export const customerBreadcrumbs: Array<{ routeId: string }> = [
	{ routeId: '/customer' },
	{ routeId: '/customer/orders' },
	{ routeId: '/customer/address-book' },
	{ routeId: '/customer/profile' }
];
